<template>
  <div class="taber-left" :class="{ auto: isWidth }">
    <div v-if="user && ((!isMobileMine || isMobileMine == 3) || inPc)">
      <div
        class="taber-user"
        @mouseenter="isType = true"
        @mouseleave="isType = false"
      >
        <div class="user-avatar">
          <img :src="user.user_avatar" v-default-avatar alt="" />
        </div>
        <div class="user-info">
          <div class="name-box">
            <p
              class="van-ellipsis info-name"
              :class="{ vip: user && user.user_vip != '0' }"
            >
              {{ user.user_nickname || "昵称未设置" }}
            </p>
            <div class="user-vip" v-if="user && user.user_vip != '0'">
              <img src="../assets/images/img_mini_vipbs.png" alt="" />
            </div>
          </div>
          <div class="info-uid">{{ user.user_name }}</div>
        </div>

        <!-- <transition name="dropdown"> -->
        <div class="pop-ul" v-if="!mobileWidth()" v-show="isType">
          <div class="type-box">
            <router-link to="/vip" class="left-box vip reject">
              <img
                class="vip-img"
                src="../assets/images/wd_img_VIPcard.png"
                alt=""
              />
              <div class="left-absolute">
                <div v-if="user && user.user_vip != '0'">
                  {{
                    !user.user_vip_expire_time ||
                    user.user_vip_expire_time.split(" ")[0]
                  }}到期
                </div>
                <div v-else>去开通</div>
                <svg-icon
                  className="vip-icon"
                  iconClass="mini_arrow_right_empty"
                ></svg-icon>
              </div>
            </router-link>
            <div class="type-ul">
              <div class="type-li" @click.stop="goFenxiao()">
                <div class="li-left">
                  <img src="../assets/images/mine_ic_distribution.png" alt="" />
                  分销推广
                </div>
                <svg-icon
                  className="tyoe-icon"
                  iconClass="mini_arrow_right_empty"
                ></svg-icon>
              </div>
              <router-link to="/setuser" class="type-li">
                <div class="li-left">
                  <img src="../assets/images/mine_ic_setting.png" alt="" />
                  设置
                </div>
                <svg-icon
                  className="tyoe-icon"
                  iconClass="mini_arrow_right_empty"
                ></svg-icon>
              </router-link>
              <div @click.stop="isService = true" class="type-li">
                <div class="li-left">
                  <img src="../assets/images/mine_ic_service.png" alt="" />
                  联系客服
                </div>
                <svg-icon
                  className="tyoe-icon"
                  iconClass="mini_arrow_right_empty"
                ></svg-icon>
              </div>
              <router-link to="/feedback" class="type-li">
                <div class="li-left">
                  <img src="../assets/images/mine_ic_help.png" alt="" />
                  意见反馈
                </div>
                <svg-icon
                  className="tyoe-icon"
                  iconClass="mini_arrow_right_empty"
                ></svg-icon>
              </router-link>
            </div>
            <hr class="hr" />
            <div class="type-botton">
              <div
                @click="openDownloadAdmin()"
                class="admin"
                v-if="user.user_type == 'admin'"
              >
                后台管理
              </div>
              <div @click="logOut()">退出登录</div>
            </div>
          </div>
        </div>
        <!-- </transition> -->
      </div>
    </div>

    <div class="taber-user tolog" v-else-if="inPc || !isMobileMine || isMobileMine == 3" @click="unLoginHandle()">
      <div class="user-avatar">
        <img v-default-avatar alt="" />
      </div>
      <div class="user-info"><div class="info-name">未登录</div></div>
    </div>

    <router-link v-if="inPc || !isMobileMine || isMobileMine == 3" class="mobile-none" to="/vip">
      <div
        class="left-box vip is"
        @mouseenter="titleShow($event, 'dom', 'Plus VIP', true)"
        @mouseleave="titleShow($event, 'dom', 'Plus VIP')"
      >
        <img
          class="vip-img"
          v-show="isWidth"
          :src="setImgUrl('/mine_img_small_VIPcard.png')"
          alt=""
        />
        <img
          class="vip-img"
          v-show="!isWidth"
          :src="setImgUrl('/mine_img_VIPcard.png')"
          alt=""
        />
        <div class="left-absolute">
          <div v-if="user && user.user_vip != '0'">
            {{
              !user.user_vip_expire_time ||
              user.user_vip_expire_time.split(" ")[0]
            }}到期
          </div>
          <div v-else>去开通</div>
          <svg-icon
            className="vip-icon"
            iconClass="mini_arrow_right_empty"
          ></svg-icon>
        </div>
      </div>
    </router-link>

    <!-- 暂时隐藏 -->
    <!-- <div
      @click="openDownloadWindow()"
      class="left-box cont-16"
      title="'下载FastAI App'"
    >
      <div class="left-img">
        <svg-icon
          className="box-icon"
          style="fill: #e6e9ed"
          iconClass="phone"
        ></svg-icon>
      </div>
      <div class="left-content"><p class="content">下载FastAI App</p></div>
      <div class="left-right">
        <img src="../assets/images/ic_arrow_right_filled.png" alt="" />
      </div>
    </div> -->

    <router-link v-if="inPc || !isMobileMine || isMobileMine == 3" class="mobile-none" to="/">
      <div
        class="left-box cont-16 home"
        @click="chatList.forEach((item) => (item.isClick = false))"
        @mouseenter="titleShow($event, 'dom', '添加专家/应用', true)"
        @mouseleave="titleShow($event, 'dom', '添加专家/应用')"
      >
        <div class="left-img">
          <svg-icon className="box-icon" iconClass="home"></svg-icon>
        </div>
        <div class="left-content">
          <p class="content-text">专家/应用中心</p>
        </div>
        <div class="left-right">
          <img src="../assets/images/ic_arrow_right_filled.png" alt="" />
        </div>
      </div>
    </router-link>

    <div v-if="inPc || !isMobileMine || isMobileMine == 3" class="type-box moblie-type" v-show="mobileWidth">
      <router-link to="/vip" class="left-box vip reject">
        <img class="vip-img" src="../assets/images/wd_img_VIPcard_mobile.png" alt="" />
        <div class="left-absolute">
          <div v-if="user && user.user_vip != '0'">
            {{
              !user.user_vip_expire_time ||
              user.user_vip_expire_time.split(" ")[0]
            }}到期
          </div>
          <div v-else>去开通</div>
          <svg-icon
            className="vip-icon"
            iconClass="mini_arrow_right_empty"
          ></svg-icon>
        </div>
      </router-link>
      <div class="type-ul">
        <div class="type-li" @click.stop="goFenxiao()" v-if="user">
          <div class="li-left">
            <img src="../assets/images/mine_ic_distribution.png" alt="" />
            分销推广
          </div>
          <svg-icon
            className="tyoe-icon"
            iconClass="mini_arrow_right_empty"
          ></svg-icon>
        </div>
        <router-link to="/setuser" class="type-li" v-if="user">
          <div class="li-left">
            <img src="../assets/images/mine_ic_setting.png" alt="" />
            设置
          </div>
          <svg-icon
            className="tyoe-icon"
            iconClass="mini_arrow_right_empty"
          ></svg-icon>
        </router-link>
        <div @click.stop="isService = true" class="type-li">
          <div class="li-left">
            <img src="../assets/images/mine_ic_service.png" alt="" />
            联系客服
          </div>
          <svg-icon
            className="tyoe-icon"
            iconClass="mini_arrow_right_empty"
          ></svg-icon>
        </div>
        <router-link to="/feedback" class="type-li">
          <div class="li-left">
            <img src="../assets/images/mine_ic_help.png" alt="" />
            意见反馈
          </div>
          <svg-icon
            className="tyoe-icon"
            iconClass="mini_arrow_right_empty"
          ></svg-icon>
        </router-link>
        <div class="type-li" @click="$store.commit('setBounceAboutUs', true)">
          <div class="li-left">
            <img src="../assets/images/mine_ic_information.png" alt="" />
            关于智能派AI
          </div>
          <svg-icon
              className="tyoe-icon"
              iconClass="mini_arrow_right_empty"
          ></svg-icon>
        </div>
      </div>
      <hr class="hr" />
      <div class="type-botton" v-if="user">
        <div @click="logOut()">退出登录</div>
      </div>
    </div>

    <hr v-if="chatList.length && (inPc || (!isMobileMine || isMobileMine == 3))" class="hr" />

    <div v-if="(!inPc && isMobileMine) ? isMobileMine == 1 : chatList.length" class="left-title historical-record">我的对话</div>

    <div
      v-if="chatList.length && (inPc || (!isMobileMine || isMobileMine == 1))"
      class="chat-list scroll-transparent"
      ref="chatList"
    >
      <div
        @click="cutWindow(item)"
        @mouseenter="titleShow($event, 'list', item.name, true)"
        @mouseleave="titleShow($event, 'list', item.name)"
        class="left-box"
        :class="{ select: item.isClick, expert: item.category == 'expert' }"
        v-for="item in chatList"
        :key="item.key"
        v-show="item.state == 'test' ? (user && user.user_type == 'admin') : true"
      >
        <div class="left-img">
          <!-- <svg-icon
            className="box-icon"
            style="fill: #e6e9ed"
            iconClass="phone"
          ></svg-icon> -->
          <van-image class="box-icon" :src="item.avatar" />
        </div>
        <div class="left-content">
          <p class="content-text van-ellipsis">{{ item.name }}</p>
          <p class="box-type">
            <span>{{ item.category == "expert" ? "专家" : "应用" }}</span>
          </p>
        </div>
        <div class="beta-icon" v-if="item.state == 'test'">beta</div>
      </div>
    </div>

    <div class="kong-box" v-else-if="!inPc && isMobileMine == 1">暂无对话</div>

    <div
      class="fixed-title"
      v-show="isTitle"
      ref="title"
      :style="{ top: titleTop + 'px' }"
    >
      {{ title }}
    </div>

    <div class="is-width" @click="getIsWidth()">
      <svg-icon
        :className="'btn-icon ' + (isWidth ? 'is' : '')"
        iconClass="arrow_left"
      ></svg-icon>
    </div>

    <PopupPC v-model="isService" round class="service-pop" title="联系客服">
      <div class="service-title">
        <div class="service-qc">
          <img src="../assets/images/wechat_service.png" alt="" />
        </div>
        <p>使用微信扫一扫，添加客服</p>
      </div>
      <van-button
        round
        block
        class="service-btn"
        type="info"
        @click="isService = false"
        >知道了</van-button
      >
    </PopupPC>
  </div>
</template>

<script>
import PopupPC from "../components/PopupPC.vue";

export default {
  name: "TaberPC",
  inject: ["mobileWidth"],
  components: { PopupPC },
  data() {
    return {
      isWidth: false,
      chatList: [],
      key: this.$route.query.key,
      isType: false,
      isService: false, // 客服弹窗

      titleTop: 0, // 鼠标移入提示高度
      title: "",
      isTitle: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    historyChatList() {
      return this.$store.state.historyChatList;
    },
    isMobileMine() {
      return this.$store.state.isMobileMine;
    },
  },
  watch: {
    "$store.state.bounceLodin": {
      handler(newVal) {
        if (newVal == true) {
          this.chatList = [];
        }
      },
    },
    historyChatList(arr) {
      this.mergeList(arr);
    },
    $route(to) {
      if (to.name != "ChatPage") {
        this.chatList.forEach((item) => (item.isClick = false));
      } else if (this.user) {
        let arr = (this.storage.get("historyChatList") || {})[
          this.user.user_name
        ];
        this.mergeList(arr || []);
      }
    },
  },
  methods: {
    titleShow(e, dom, naem, is) {
      if (!this.isWidth) {
        this.isTitle = false;
        return false;
      }
      let Top = 0;
      if (dom == "list") {
        Top =
          this.$refs.chatList.offsetTop +
          (e.target.offsetTop - this.$refs.chatList.scrollTop);
      } else {
        Top = e.target.offsetTop;
      }

      let titleHeight = this.$refs.title.offsetHeight;
      let elHeight = e.target.offsetHeight;

      console.log("elHeight / 2 - titleHeight / 2", elHeight, titleHeight);

      this.titleTop = Top + elHeight / 2;
      this.title = naem;
      this.isTitle = is;
    },
    getIsWidth() {
      this.$store.commit("setIsWidth", !this.isWidth);
      this.isWidth = !this.isWidth;
    },
    openDownloadWindow() {
      window.open("/chat/download", "_blank");
    },
    openDownloadAdmin() {
      window.open("/admin", "_blank");
    },
    mergeList(arr) {
      if (!this.user) {
        return false;
      }
      let mergedArray = this.$tools.mergeGrade(this.chatList, arr, "key");

      this.chatList = mergedArray;
      this.chatList.forEach((item) => (item.isClick = false));

      let isMobileMine = sessionStorage.getItem('setIsMobileMine');
      if(!this.chatList.length && !isMobileMine){
        this.$store.commit('setIsMobileMine', false);
        sessionStorage.removeItem('setIsMobileMine');
      } else if(!this.$route.query.category) {
        this.$store.commit('setIsMobileMine', isMobileMine || 1);
      }

      let key = this.$route.query.key;

      if (key) {
        this.chatList.forEach((ele) => {
          if (ele.key == key) {
            ele.isClick = true;
            // ele.time = new Date();
          }
        });

        // 进行时间排序，当前点击排到最前面
        this.chatList.sort(this.customSort);
        this.bottomScroll();
      }

      if (this.user) {
        let historyChatList = this.storage.get("historyChatList") || {};

        // let currentAccountObj = historyChatList[this.user.user_name];
        historyChatList[this.user.user_name] = this.chatList;

        this.storage.set("historyChatList", historyChatList);
      }
    },
    bottomScroll() {
      this.$nextTick(() => {
        let list = this.$refs.chatList;
        let select = this.$refs.chatList.querySelectorAll(".select")[0];
        if (!select) {
          return false;
        }
        let sTop = select.offsetTop;
        let top = list.scrollTop + list.clientHeight / 2;
        let height = list.scrollHeight + list.clientHeight;

        // if (sTop > top) {
        list.scrollTop = sTop - list.clientHeight / 2;
        // }
      });
    },
    goFenxiao() {
      window.open("/chat/home", "_blank");
    },
    customSort(a, b) {
      const hasTimeA = a.hasOwnProperty("time");
      const hasTimeB = b.hasOwnProperty("time");

      if (hasTimeA && hasTimeB) {
        // 如果两个对象都有 time 属性，则按照时间进行排序
        return new Date(b.time) - new Date(a.time);
      } else if (hasTimeA && !hasTimeB) {
        return -1; // 将有 time 的对象排在没有 time 的对象之前
      } else if (!hasTimeA && hasTimeB) {
        return 1; // 将没有 time 的对象排在有 time 的对象之后
      } else {
        return 0; // 其他情况保持原有的顺序不变
      }
    },
    getChatList() {
      let qsData = {
        needToken: true,
      };

      return this.$axios
        .get("/user/chatList", { params: qsData })
        .then((res) => {
          let result = res.data;

          if (result.errorno) {
            // this.$toast(result.error);
            this.$store.commit('setIsMobileMine', false);
            localStorage.removeItem('setIsMobileMine');
            return;
          }

          var chatList = result.data;

          // if (this.historyChatList) {
          //   let mergedArray = this.$tools.mergeGrade(
          //     chatList,
          //     this.historyChatList,
          //     "key"
          //   );

          //   this.chatList = mergedArray;
          // } else {
          this.chatList = chatList || [];
          // }

          if (this.user) {
            let arr = (this.storage.get("historyChatList") || {})[
              this.user.user_name
            ];
            this.mergeList(arr || []);
          }
        });
    },
    cutWindow(item) {
      if (this.$route.query.key == item.key) {
        return false;
      }

      // this.chatList.forEach((ele) => {
      //   if (ele.key == item.key) {
      //     ele.isClick = true;
      //     // ele.time = new Date();
      //   } else {
      //     ele.isClick = false;
      //   }
      // });

      // this.$store.commit("sethistoryChatList", this.chatList);

      this.$router
        .replace({
          name: "ChatPage",
          query: { key: item.key, category: item.category },
        })
        .then((res) => {
          if (this.user) {
            let arr = (this.storage.get("historyChatList") || {})[
              this.user.user_name
            ];
            this.mergeList(arr || []);
          }
        });
    },
  },
  created() {
    this.getChatList();
  },
};
</script>

<style lang="less" scoped>
.fixed-title {
  position: absolute;
  left: calc(100% + 8px);
  background: #fff;
  z-index: 1;
  white-space: nowrap;
  transform: translateY(-50%);
  background: #000000;
  background: var(--tips-title-color);
  border-radius: 24px;
  line-height: 32px;
  color: #e6e9ed;
  color: var(--Gray_05);
  padding: 0 16px;
  font-size: 12px;
}

.taber-left {
  position: relative;
  border: 1px solid #1a3d5a;
  border: 1px solid var(--Gray_03);
  border-radius: 0px 32px 0px 0px;
  border-left: none;
  border-bottom: none;
  flex-shrink: 0;
  margin-right: 71px;
  padding: 24px 24px 0;
  display: flex;
  flex-direction: column;
}

.is-width {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 64px;
  border: 1px solid #1a3d5a;
  border: 1px solid var(--Gray_03);
  border-radius: 0px 8px 8px 0px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    .btn-icon {
      fill: #00e3f9;
      fill: var(--Cyan_01);
    }
  }
  .btn-icon {
    fill: #e6e9ed;
    fill: var(--individual-arrow-color);

    &.is {
      transform: rotate(180deg);
    }
  }
}

.taber-user {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  position: relative;

  &.tolog {
    cursor: pointer;
  }

  .user-avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .user-info {
    margin-left: 8px;
    flex: 1;
    // ie中会导致高度过高
    // width: 0;

    .name-box {
      display: flex;
      align-items: center;
    }

    .info-name {
      color: #e6e9ed;
      color: var(--Gray_05);
      font-size: 16px;
      font-weight: bold;
      line-height: 1;
      max-width: 180px;

      &.vip {
        background: linear-gradient(90deg, #c3df48 0%, #80f4ff 100%);
        background: linear-gradient(
          90deg,
          var(--title-vip-color-begin) 0%,
          var(--title-vip-color-ending) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        width: max-content;
      }
    }
    .info-uid {
      color: #989fad;
      color: var(--Gray_04);
      font-size: 12px;
      margin-top: 8px;
    }
  }

  .user-vip {
    flex-shrink: 0;
    width: 32px;
    height: 100%;
    font-size: 0;
    margin-left: 4px;

    img {
      width: 100%;
    }
  }

  .pop-ul {
    position: absolute;
    padding-top: 16px;
    top: 100%;
    left: 0;
    z-index: 6;
  }
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: all 0.5s;
  }

  .dropdown-enter,
  .dropdown-leave-to {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.type-box {
  background: #002748;
  background: var(--Gray_02);
  padding: 15px;
  border-radius: 16px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);
  border: 1px solid #1a3d5a;
  border: 1px solid var(--Gray_03);

  .type-ul {
    margin-top: 16px;

    .type-li {
      cursor: pointer;
      height: 56px;
      display: flex;
      align-items: center;
      height: 56px;
      border-radius: 8px;
      padding: 0 16px;

      .li-left {
        display: flex;
        align-items: center;
        color: #e6e9ed;
        color: var(--Gray_05);
        font-size: 14px;
        flex: 1;
        width: 0;

        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
          flex-shrink: 0;
        }
      }

      .tyoe-icon {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
        fill: #e6e9ed;
        fill: var(--Gray_05);
      }

      &:hover {
        background: #1a3d5a;
        background: var(--Gray_03);
      }
    }
  }

  .type-botton {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00e3f9;
    color: var(--Cyan_01);
    font-size: 14px;

    div {
      cursor: pointer;
    }

    .admin {
      margin-right: auto;
      color: #989fad;
      color: var(--Gray_04);
    }
  }

  .hr {
    margin: 16px 0;
  }

  .left-box {
    margin: 0;
  }

  &.moblie-type{
    display: none;
  }
}

.chat-list {
  overflow-y: auto;
  overflow-x: visible;
  flex-grow: 1;
  height: 0;
  margin-top: 16px;
  padding-bottom: 16px;
  margin-right: -24px;
  scroll-behavior: smooth;
  position: relative;

  .left-box {
    &:first-child {
      margin: 0;
    }
  }
}

.left-box {
  width: 252px;
  background: #002748;
  background: var(--Gray_02);
  border: 1px solid #002748;
  border: 1px solid var(--Gray_02);
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  display: flex;
  cursor: pointer;
  align-items: center;
  position: relative;
  overflow: hidden;
  // flex-shrink: 0;

  &.expert {
    .left-img {
      border-radius: 50%;
      overflow: hidden;
    }
  }

  &.cont-16 {
    .left-img {
      width: 24px;
      height: 24px;
    }
    .left-content {
      .content-text {
        font-size: 16px;
      }
    }
  }

  .left-img {
    width: 40px;
    height: 40px;

    .box-icon {
      width: 100%;
      height: 100%;
    }
  }

  .left-content {
    flex: 1;
    width: 0;
    margin: 0 8px;

    .content-text {
      color: #e6e9ed;
      color: var(--Gray_05);
      font-weight: bold;
      font-size: 14px;
    }

    .box-type {
      display: flex;
      flex-wrap: wrap;
      margin-top: 8px;

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 8px;
        background: rgba(255, 255, 255, 0.1);
        background: var(--left-type-color);
        height: 16px;
        font-size: 12px;
        color: #989fad;
        color: var(--Gray_04);
        border-radius: 8px;
      }
    }
  }

  .left-right {
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .beta-icon {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0 0 0 0.5rem;
    color: #00e3f9;
    color: var(--Cyan_01);
    font-size: 12px;
    background: #001235;
    background: var(--Gray_01);
    padding: 4px 6px;
  }

  &.center {
    background: transparent;
    border: 1px solid #1a3d5a;
    border: 1px solid var(--Gray_03);
    justify-content: center;

    .left-content {
      flex: 0;
      width: auto;
      white-space: nowrap;

      .content-text {
        color: #00e3f9;
        color: var(--Cyan_01);
        font-size: 16px;
      }
    }
    .add-img {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      margin-right: 8px;
    }

    &:hover {
      background: #002748;
      background: var(--Gray_02);
    }
  }

  &.vip {
    padding: 0;
    margin-top: 24px;
    border: none;
    display: block;
    font-size: 0;

    .vip-img {
      width: 100%;
    }

    .left-absolute {
      position: absolute;
      display: flex;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      background: linear-gradient(90deg, #c3df48 0%, #80f4ff 100%);
      background: linear-gradient(
        90deg,
        var(--Ygreen_01) 0%,
        var(--Cyan_02) 100%
      );
      font-size: 12px;
      color: #002748;
      color: var(--font-color-vip);
      align-items: center;
      padding: 0 8px 0 12px;
      height: 24px;
      border-radius: 23px;
      font-weight: bold;

      .vip-icon {
        width: 8px;
        height: 8px;
        fill: #002748;
        fill: var(--font-color-vip);
        flex-shrink: 0;
        margin-left: 4px;
      }
    }

    &.reject {
      .left-absolute {
        background: #fff;
      }
    }
  }

  &.home {
    background: linear-gradient(90deg, #c3df48 0%, #80f4ff 100%);
    background: linear-gradient(
      90deg,
      var(--Ygreen_01) 0%,
      var(--Cyan_02) 100%
    );
    height: 64px;

    .box-icon {
      fill: #001235;
      fill: var(--dazzling-btn-color);
    }

    .left-content {
      .content-text {
        color: #001235;
        color: var(--dazzling-btn-color);
      }
    }

    &:hover {
      background: linear-gradient(90deg, #c3df48 0%, #80f4ff 100%);
      background: linear-gradient(
        90deg,
        var(--Ygreen_01) 0%,
        var(--Cyan_02) 100%
      );
    }
  }

  &.select {
    border-color: #00e3f9;
    border-color: var(--Cyan_01);
    background: #002748;
    background: var(--special-option-base-color);

    .left-content {
      .content-text {
        color: #00e3f9;
        color: var(--Cyan_01);
      }
    }
  }

  &:hover {
    background: #1a3d5a;
    background: var(--Gray_03);
  }
}

.left-title {
  color: #e6e9ed;
  color: var(--Gray_05);
  font-size: 18px;
  font-weight: bold;
  flex-shrink: 0;
}

.kong-box{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #989FAD;
  font-size: 0.9375rem;
}

.auto {
  .taber-user {
    margin-bottom: 24px;

    .user-info {
      display: none;
    }
  }

  .chat-list {
    margin-top: 0px;

    .left-box {
      margin-bottom: 24px;
    }
  }

  .left-box:not(.reject) {
    width: 56px;
    padding: 7px;
    border-radius: 50%;
    height: 56px;
    margin-top: 24px;
    justify-content: center;

    &.cont-16 {
      .left-img {
        width: 32px;
        height: 32px;
      }
    }

    .left-content,
    .left-right {
      display: none;
    }

    &.center {
      padding: 0;
      border: none;
      margin-bottom: 0;

      .add-img {
        width: 100%;
        height: 100%;
        margin: 0;
      }
    }

    &.vip {
      padding: 0;
      margin-top: 0;
      height: auto;
      border-radius: 0;
      background: transparent;

      .vip-img {
        width: 56px;
      }

      .left-absolute {
        display: none;
      }
    }
  }

  .left-title {
    font-size: 14px;
  }
}

.service-pop.center {
  background: #002748;
  background: var(--special-pop-underpainting);

  .service-title {
    font-size: 0;

    .service-qc {
      width: 160px;
      height: 160px;
      padding: 16px;
      background: #fff;
      border-radius: 8px;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    p {
      margin-top: 16px;
      color: #e6e9ed;
      color: var(--Gray_05);
      font-size: 16px;
    }
  }

  .service-btn {
    margin-top: 32px;
    background: linear-gradient(90deg, #c3df48 0%, #80f4ff 100%);
    background: linear-gradient(
      90deg,
      var(--Ygreen_01) 0%,
      var(--Cyan_02) 100%
    );
    font-size: 18px;
    color: #001235;
    color: var(--dazzling-btn-color);
    font-weight: bold;
    border: none;
  }
}

.hr {
  background: #1a3d5a;
  background: var(--Gray_03);
  margin: 24px 0;
}

@media screen and (max-width: 768px) {
  .type-box.moblie-type{
    display: block;
    background: none;
    border: none;
    padding: 0;
    margin: 1.5rem 0 1rem;

    .type-ul{
      margin-top: 0;
      background: #002748;
      border-radius: 1rem;
      overflow: hidden;
      
      .type-li{
        padding: 0 1rem;
        //margin-top: 1rem;
        //height: auto;

        .li-left{
          //font-size: 1rem;

          //img{
          //  width: 1.5rem;
          //  height: 1.5rem;
          //}
        }
      }
    }

    .type-botton{
      margin-top: .5rem;
      background: #002748;
      border-radius: 1rem;
      height: 56px;
      //font-size: 1rem;
      padding: 0 3rem;
    }

    .left-box.vip{
      width: calc(100% - 3rem);
      margin: 0 auto;
      border-radius: 0;

      .left-absolute{
        right: .75rem;
        padding: 0 .625rem 0 .75rem;
        //font-size: .875rem;

        .vip-icon{
          //width: .75rem;
          //height: .75rem;
        }
      }
    }
  }

  .left-title.historical-record{
    font-size: 0;
    margin-top: -.5rem;

    &::after{
      display: block;
      content: '';
      background: url("../assets/images/historical-icon.png") no-repeat;
      background-size: 100% 100%;
      width: 7rem;
      height: 1.75rem;

    }
  }

  .hr{
    display: none;
  }

  .mobile-none{
    display: none;
  }

  .is-width{
    display: none;
  }

  .service-pop.center{
    width: 20rem;
    min-width: auto;
    padding: 2rem;

    /deep/ .title{
      font-size: 1.125rem;
      margin-bottom: 2rem;
    }

    .service-title{
      font-size: 1rem;

      .service-qc{
        width: 10rem;
        height: 10rem;
      }
    }

    .service-btn{
      margin-top: 2rem;
      font-size: 1rem;
    }

  }

}

</style>


// WEBPACK FOOTER //
// src/views/TaberPC.vue